import React from "react"
import { Route } from "react-router-dom"
import {
  SemiPrivateRouteWithData,
  ResetPasswordRoute,
  PrivateRouteWithData,
} from "../shared/routeHandlers"
import qs from "qs"

// Views
import Home from "../views/Home"
import LiveResults from "../views/LiveResults"
import LiveResultsFlashStudy from "../views/LiveResultsFlashStudy"
import Research from "../views/Research"
import ErrorScreen from "../views/ErrorScreen"
import RegisterDevice from "../views/RegisterDevice"
import Login from "../views/Login"
import ResetPassword from "../views/ResetPassword"
import Topic from "../views/Topic"
import AccountLanding from "../views/AccountLanding"
import Marketplace from "../views/Marketplace"
import ProductDetails from "../views/ProductDetails"
import MyFavorites from "../views/MyFavorites"
import ViewProduct from "../views/ViewProduct"
import Help from "../views/Help"
import EtrInsights from "../views/EtrInsights"
import EtrInsightsCalendar from "../views/EtrInsightsCalendar"
import EtrInsightsAbout from "../views/EtrInsightsAbout"
import EtrInsightsSearch from "../views/EtrInsightsSearch"
import AboutDrillDowns from "../views/AboutDrillDowns"
import AboutETS from "../views/AboutETS"
import AboutTSIS from "../views/AboutTSIS"
import Newsletter from "../views/Newsletter"
import Post from "../views/Post"
import Archive from "../views/Archive"
import Restricted from "../views/Restricted"
import EtrInsightsMarketing from "../views/EtrInsightsMarketing"
import InteractiveDemo from "../views/InteractiveDemo"
import InteractiveDemoReportView from "../views/InteractiveDemo/components/ReportView"
import Drilldowns from "../views/DrillDowns"
import URL from "../views/URL"
import Model from "../views/Model"
import PaymentPolicy from "../views/PaymentPolicy"
import TermsAndConditions from "../views/TermsAndConditions"
import { MarketArraySearch, MarketArrayReport } from "../views/MarketArray"
import { InteractiveReport } from "../views/InteractiveReport"
import ObservatoryBundles from "../views/ObservatoryBundles"
import AiProductSeries from "../views/AiProductSeries"
import ViewAiProductSeries from "../views/ViewAiProductSeries"

const NotFoundScreen = (props) => (
  <ErrorScreen {...props} message="Page Not Found" backToHome />
)

const routes = [
  {
    path: "/",
    component: Home,
    exact: true,
    routeType: ResetPasswordRoute,
  },
  {
    path: "/liveresults",
    component: LiveResults,
    exact: true,
    routeType: ResetPasswordRoute,
    pageName: "LiveResults",
  },
  {
    path: "/drill-downs",
    component: Drilldowns,
    exact: true,
    routeType: ResetPasswordRoute,
    pageName: "DrillDowns",
  },
  {
    path: "/etr-insights/search/about",
    component: EtrInsightsMarketing,
    exact: true,
    routeType: Route,
    pageName: "VennMarketing",
  },
  {
    path: "/flash-study-live-results",
    component: LiveResultsFlashStudy,
    exact: true,
    routeType: ResetPasswordRoute,
    pageName: "LiveResultsFlashStudy",
  },
  {
    path: "/login",
    component: Login,
    exact: true,
    routeType: Route,
    pageName: "Login",
  },
  {
    path: "/register-device",
    component: RegisterDevice,
    exact: true,
    routeType: SemiPrivateRouteWithData,
    pageName: "Register Device",
  },
  {
    path: "/interactive-demo",
    component: InteractiveDemo,
    exact: true,
    routeType: Route,
    fullscreen: true,
    pageName: "Interactive Demo",
  },
  {
    path: "/interactive-demo/reports/:productId",
    component: InteractiveDemoReportView,
    exact: true,
    routeType: Route,
    fullscreen: true,
    pageName: "Interactive Demo",
  },
  {
    path: "/marketplace",
    component: Marketplace,
    exact: true,
    routeType: ResetPasswordRoute,
    pageName: "Marketplace",
  },
  {
    path: "/reset-password",
    component: ResetPassword,
    exact: true,
    routeType: Route,
    pageName: "Reset Password",
  },
  {
    path: "/account",
    component: AccountLanding,
    routeType: SemiPrivateRouteWithData,
  },
  {
    path: "/payment-policy",
    component: PaymentPolicy,
    routeType: Route,
    pageName: "Privacy Policy",
  },
  {
    path: "/terms-and-conditions",
    component: TermsAndConditions,
    routeType: Route,
    pageName: "Terms and Conditions",
  },
  {
    path: "/help",
    component: Help,
    routeType: ResetPasswordRoute,
    pageName: "Help",
  },
  {
    path: "/observatory-bundles",
    exact: true,
    component: ObservatoryBundles,
    routeType: PrivateRouteWithData,
    pageName: "Observatory Bundles",
  },
  {
    path: "/ai-product-series",
    exact: true,
    component: AiProductSeries,
    routeType: PrivateRouteWithData,
    pageName: "AI Product Series",
  },
  {
    path: "/ai-product-series/:bundleSlug/:slug",
    exact: true,
    component: ViewAiProductSeries,
    routeType: PrivateRouteWithData,
    pageName: "AI Product Series View",
    fullscreen: ({ location }) =>
      qs.parse(location.search, { ignoreQueryPrefix: true }).type !== "html",
  },
  {
    path: "/market-array",
    exact: true,
    component: MarketArraySearch,
    routeType: PrivateRouteWithData,
    pageName: "Market Array Search",
  },
  {
    path: "/market-array/:slug",
    exact: true,
    component: MarketArrayReport,
    routeType: PrivateRouteWithData,
    pageName: "Market Array Report",
  },
  {
    path: "/interactive-reports/tsis-forecasts/:slug",
    exact: true,
    // eslint-disable-next-line react/display-name
    component: (props) => <InteractiveReport {...props} role="TSISForecasts" />,
    routeType: PrivateRouteWithData,
    pageName: "TSIS Forecast Report",
  },
  {
    path: "/research/drill-downs/:slug",
    exact: true,
    component: Model,
    routeType: PrivateRouteWithData,
    pageName: "Model",
  },
  {
    path: "/:dataset(research|admin-bi|ets)/:book/:chapter",
    exact: true,
    isResearch: true,
    fullscreen: ({ location }) =>
      qs.parse(location.search, { ignoreQueryPrefix: true }).fullscreen ===
      "true",
    component: Research,
    routeType: Route,
  },
  {
    path: "/ets",
    component: AboutETS,
    routeType: ResetPasswordRoute,
    pageName: "ETS",
    exact: true,
    isETS: true,
  },
  {
    path: "/research/tsis",
    component: AboutTSIS,
    routeType: ResetPasswordRoute,
    pageName: "Tsis",
    exact: true,
  },
  {
    path: "/research/drill-downs",
    component: AboutDrillDowns,
    routeType: ResetPasswordRoute,
    pageName: "DrillDowns",
    exact: true,
  },
  {
    path: "/marketplace/:product",
    exact: true,
    component: ProductDetails,
    routeType: ResetPasswordRoute,
  },
  {
    path: "/marketplace/:slug/view",
    exact: true,
    fullscreen: true,
    component: ViewProduct,
    routeType: ResetPasswordRoute,
  },
  {
    path: "/favorites",
    component: MyFavorites,
    exact: true,
    routeType: ResetPasswordRoute,
  },
  {
    path: "/favorites/:folderId",
    component: MyFavorites,
    routeType: ResetPasswordRoute,
  },
  {
    path: "/:type(vendor|sector)/:slug",
    exact: true,
    component: Topic,
    routeType: ResetPasswordRoute,
  },
  {
    path: "/etr-insights",
    component: EtrInsights,
    routeType: ResetPasswordRoute,
    pageName: "ETR Insights",
    exact: true,
  },
  {
    path: "/etr-insights/calendar",
    component: EtrInsightsCalendar,
    routeType: ResetPasswordRoute,
    pageName: "ETR Insights Calendar",
    exact: true,
  },
  {
    path: "/etr-insights/about",
    component: EtrInsightsAbout,
    routeType: ResetPasswordRoute,
    pageName: "About ETR Insights",
    exact: true,
  },
  {
    path: "/etr-insights/search",
    component: EtrInsightsSearch,
    routeType: ResetPasswordRoute,
    pageName: "ETR Insights Search",
    exact: true,
  },
  {
    path: "/newsletter",
    component: Newsletter,
    routeType: ResetPasswordRoute,
    pageName: "Newsletter",
  },
  {
    path: "/newsletters/archive",
    component: Archive,
    routeType: ResetPasswordRoute,
    pageName: "Archive",
  },
  {
    path: "/restricted",
    component: Restricted,
    routeType: Route,
    pageName: "Restricted",
  },
  {
    path: "/:type(newsletters|articles)/:id/preview",
    component: Post,
    routeType: ResetPasswordRoute,
  },
  {
    path: "/:type(newsletters|articles)/:slug",
    component: Post,
    routeType: ResetPasswordRoute,
  },
  {
    path: "/url/:slug",
    component: URL,
    routeType: ResetPasswordRoute,
  },
  {
    path: "/not-found",
    component: NotFoundScreen,
    routeType: Route,
    pageName: "404",
  },
  {
    component: NotFoundScreen,
    routeType: Route,
    pageName: "404",
  },
]

export default routes
